import {
  HTTP_CALL_BEGIN,
  HTTP_CALL_END,
  SIGNIN_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  REGISTER_MODAL,
  LOGIN_MODAL,
  SUCCESS_MODAL
} from "../constants";

const initialState = {
  loading: false,
  user: {},
  loginModal: false,
  registerModal: false,
  successModal: false
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
  case HTTP_CALL_BEGIN:
    return {
      ...state,
      loading: true,
    };
  case HTTP_CALL_END:
    return {
      ...state,
      loading: false,
    };
  case SIGNIN_USER_SUCCESS:
    return {
      ...state,
      user: action.payload,
    };
  case SIGNUP_USER_SUCCESS:
    return {
      ...state,
      user: action.payload,
    };
  case REGISTER_MODAL:
    return {
      ...state,
      registerModal: !state.registerModal,
    };
  case LOGIN_MODAL:
    return {
      ...state,
      loginModal: !state.loginModal,
    };
  case SUCCESS_MODAL:
    return {
      ...state,
      successModal: !state.successModal,
    };
  default:
    return state;
  }
}
